export const calculateSubjectAttendancePercentage = (presentCount, totalSessions) => {
    if (typeof presentCount !== 'number' || typeof totalSessions !== 'number' || totalSessions === 0) {
        return 0;
    }
    const percentage = (presentCount / totalSessions) * 100;
    return Number(percentage.toFixed(2)); // Return as number
};

export const groupAttendanceBySubject = (subjectAttendance) => {
    const attendanceBySubject = {};

    subjectAttendance?.forEach((attendance) => {
        const subName = attendance?.subName?.subName || 'Unknown';
        const subId = attendance?.subName?._id || 'unknown';

        if (!attendanceBySubject[subName]) {
            attendanceBySubject[subName] = {
                present: 0,
                sessions: 0,
                allData: [],
                subId: subId
            };
        }
        
        // Increment total sessions for each attendance entry
        attendanceBySubject[subName].sessions += 1;
        
        if (attendance.status.toLowerCase() === "present") {
            attendanceBySubject[subName].present++;
        }
        
        attendanceBySubject[subName].allData.push({
            date: attendance.date,
            status: attendance.status,
        });
    });
    
    return attendanceBySubject;
};
  
export const calculateOverallAttendancePercentage = (subjectAttendance) => {
    const grouped = groupAttendanceBySubject(subjectAttendance);
    
    let totalPossibleSessions = 0;
    let totalPresent = 0;

    Object.values(grouped).forEach(subject => {
        totalPossibleSessions += subject.sessions;
        totalPresent += subject.present;
    });

    if (totalPossibleSessions === 0) return 0;
    
    const overallPercentage = (totalPresent / totalPossibleSessions) * 100;
    return Number(overallPercentage.toFixed(2));
};